// extracted by mini-css-extract-plugin
export var accent = "_2p-4";
export var add = "_2p-j";
export var addIcon = "_2p-k";
export var deleteIcon = "_2p-i";
export var disabled = "_2p-9";
export var ellipsis = "_2p-f";
export var error = "_2p-3";
export var form = "_2p-5";
export var hideFocus = "_2p-2";
export var icon = "_2p-7";
export var input = "_2p-e";
export var listItem = "_2p-h";
export var mediumHeight = "_2p-b";
export var noBorder = "_2p-8";
export var noRadius = "_2p-1";
export var shortHeight = "_2p-a";
export var tallHeight = "_2p-c";
export var textInput = "_2p-0";
export var vertical = "_2p-g";
export var veryTallHeight = "_2p-d";
export var widget = "_2p-6";